import { React, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

import CTAButton from '../CTAButton/CTAButton.js'

import { URL_MAINAPI, API_TOKEN, validatePassword } from '../../main.js'

import '../../main.css'
import './PasswordForm.css'

import Cookies from 'universal-cookie'


export default function PasswordForm(props) {

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    var [status, setStatus] = useState("")
    var [message, setMessage] = useState("")
    var [formData, setFormData] = useState({
        formPasswort: "",
        formPasswort2: ""
    })

    function showResult(newStatus, newMessage) {
        setStatus(newStatus)
        setMessage(newMessage)
    }

    async function doSetPW() {
        if (formData.formPasswort !== formData.formPasswort2) {
            showResult("error", "Passwörter stimmen nicht überein.")
            return
        }
        if (validatePassword(formData.formPasswort).error != null) {
            showResult("error", "Das Passwort muss mindestens 1 Sonderzeichen, 1 Zahl und 1 Großbuchstaben enthalten (6–30 Zeichen).")
            return
        }

        showResult("loading", "")
        try {
            const res = await fetch(URL_MAINAPI + "/auth/set-pw", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify({ "password": formData.formPasswort }),
            })
            const data = await res.json()
            if (res.status === 200) {
                showResult("done", props.hasPassword ? "Dein Passwort wurde geändert." : "Dein Passwort wurde gespeichert. Du kannst dich ab jetzt auch mit Passwort anmelden.")
                setFormData({ formPasswort: "", formPasswort2: "" })
            } else {
                showResult("error", data.error)
            }
        } catch (err) {
            showResult("error", String(err))
        }
    }

    return (
        <form className='pwform' onSubmit={(e) => { e.preventDefault(); doSetPW() }}>
            <div className="field">
                <label htmlFor="setpw-passwort">{props.hasPassword ? 'Neues Passwort' : 'Dein Passwort'}</label>
                <input id="setpw-passwort" type="password" maxLength="30" minLength="6" name="passwort" placeholder="Passwort" value={formData.formPasswort} autoComplete='new-password' onInput={(e) => setFormData({ ...formData, formPasswort: e.target.value })}></input>
            </div>
            <div className="field">
                <label htmlFor="setpw-passwort2">Passwort wiederholen</label>
                <input id="setpw-passwort2" type="password" maxLength="30" minLength="6" name="passwort2" placeholder="Passwort wiederholen" value={formData.formPasswort2} autoComplete='new-password' onInput={(e) => setFormData({ ...formData, formPasswort2: e.target.value })}></input>
            </div>

            <p className='pwform-hint'>Das Passwort muss mindestens 1 Sonderzeichen, 1 Zahl und 1 Großbuchstaben haben!</p>

            <div style={{ marginTop: '18px' }}>
                <CTAButton variant="secondary" hideArrow={false} disabled={status === "loading"} title={props.hasPassword ? "Passwort ändern" : "Passwort speichern"} onclick={() => doSetPW()} />
            </div>

            {(status === "loading") ? (
                <div className='status-banner status-banner--info' role="status">
                    <FontAwesomeIcon icon={faCircleInfo} /> <span>Lädt... Bitte warten...</span>
                </div>
            ) : null}
            {(status === "done") ? (
                <div className='status-banner status-banner--success' role="status">
                    <FontAwesomeIcon icon={faCircleInfo} /> <span>Erfolgreich. {message}</span>
                </div>
            ) : null}
            {(status === "error") ? (
                <div className='status-banner status-banner--error' role="alert">
                    <FontAwesomeIcon icon={faCircleInfo} /> <span>Bitte überprüfe deine Eingaben!<br />Fehler: {message}</span>
                </div>
            ) : null}
        </form>
    )
}
